import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PharmacyEffects } from './effects/pharmacy.effects';
import { pharmacyReducer } from './reducers/pharmacy.reducer';

@NgModule({
  imports: [StoreModule.forFeature('pharmacyData', pharmacyReducer), EffectsModule.forFeature([PharmacyEffects])],
})
export class PharmacyStoreModule {}
